import { useState, type KeyboardEvent } from 'react';
import { Box, IconButton, TextField, Tooltip } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { useTranslation } from 'react-i18next';
import { useAssistantStore } from '@/stores/assistantStore';
import { useAssistantChat } from '@/hooks/useAssistantChat';

export function ChatInput() {
  const { t } = useTranslation('assistant');
  const [input, setInput] = useState('');
  const isLoading = useAssistantStore((s) => s.isLoading);
  const { sendMessage } = useAssistantChat();

  const handleSend = () => {
    const trimmed = input.trim();
    if (!trimmed || isLoading) return;
    setInput('');
    void sendMessage(trimmed);
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        gap: 1,
        p: 2,
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <TextField
        fullWidth
        multiline
        maxRows={4}
        size="small"
        placeholder={t('placeholder')}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={isLoading}
        slotProps={{
          input: {
            sx: { borderRadius: 2 },
          },
        }}
      />
      <Tooltip title={t('send')}>
        <span>
          <IconButton
            color="primary"
            onClick={handleSend}
            disabled={!input.trim() || isLoading}
            aria-label={t('send')}
          >
            <SendIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
}
